import React from 'react';
import { Link } from 'gatsby';

import CDNImage from "../../common/cdn-image";

import '../../../styles/shop/print-long-info.scss';

const PrintShippingInfo = () => {
	return (
		<div className="print-long-info-container">
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/packing.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Packing
					</p>
					<p className="body">
						All prints, unframed and framed, will be expertly and securely packed to make sure they
						arrive in top condition. (In the rare case where damage occurs in transit, a full refund
						or replacement will be offered, see <b>Returns</b> below.)
					</p>
				</div>
			</div>
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/delivery-cost.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Delivery cost
					</p>
					<p className="body">
						<b><i>FREE SHIPPING</i></b> for all orders to US, UK, EU, Canada and Australia.
					</p>
					<p className="body">
						For all other destinations, a shipping charge is in place: unframed (per order): $6.50; framed (per item): $20.
					</p>
				</div>
			</div>
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/delivery-time.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Delivery time
					</p>
					<p className="body">
						All prints, framed and unframed, are sent via a tracked service (tracking link will be emailed to
						you after dispatch). Unfortunately, we are unable to deliver to PO Boxes. Estimated delivery
						times from purchase are:
					</p>
					<table>
						<thead>
							<tr>
								<th></th>
								<th id="core">UK/US/EU/Can/Aus</th>
								<th id="row">Rest of World</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th id="unframed">Unframed</th>
								<td headers="core unframed">6 to 12 business days</td>
								<td headers="row unframed">15 to 25 business days</td>
							</tr>
							<tr>
								<th id="framed">Framed</th>
								<td headers="core framed">10 to 20 business days</td>
								<td headers="row framed">15 to 30 business days</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/duty.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Duty
					</p>
					<p className="body">
						No duty fees will be incurred if ordering to US, UK, EU, Canada or Australia, as the prints are
						locally produced. If ordering to other countries you may be required to pay duty to claim your package,
						depending on your local customs office.
					</p>
				</div>
			</div>
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/returns.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Returns and Refunds
					</p>
					<p className="body">
						As the prints are custom made (specifically for the image, size, and frame colour you have chosen)
						then we can only accept returns or refunds in the case of incorrect or damaged goods. For more info
						see our <Link to="/returns-policy">Returns Policy</Link>.
					</p>
				</div>
			</div>
		</div>
	);
};

export default PrintShippingInfo;